import { NavItem } from './TopLevelNavItemContext';

export const rideOrderingPortalTopLevelNavItems: NavItem[] = [
  { name: 'Trips', href: '/trips' },
  { name: 'Passengers', href: '/passengers' },
  { name: 'Team', href: '/team' },
  { name: 'Map', href: '/live-map' },
];
